/**
 * authz.js — คำนิยาม "ใครคือแอดมิน" ที่เดียวของทั้งหน้าเว็บ
 *
 * ── ทำไมต้องมีไฟล์นี้ ────────────────────────────────────────────────────
 * เดิมคำนิยามนี้กระจายอยู่ 3 ที่ และไม่ตรงกันสักคู่:
 *
 *   usePermission.js  → userInfo.isAdmin อย่างเดียว
 *   AdminRoute.jsx    → isAdmin หรือแผนก EXEC/ADMIN
 *   navCatalog.js     → role ADMIN หรือ isAdmin หรือแผนก EXEC/ADMIN
 *
 * ผลคือคนแผนก EXEC ที่ไม่ได้ติ๊ก isAdmin เห็นเมนูแอดมินครบ (navCatalog ให้ผ่าน)
 * ผ่านด่าน route ได้ (AdminRoute ให้ผ่าน) แต่ปุ่มในหน้าหายหมด (usePermission
 * ไม่ให้ผ่าน) — บั๊กนี้ถูกบันทึกไว้ในคอมเมนต์ของ AdminRoute.jsx เองว่าเกิดจริง
 *
 * ก่อนจะย้ายทั้งระบบไปใช้ RequirePermission ต้องรวมนิยามให้เหลือชุดเดียวก่อน
 * ไม่งั้นจะลากบั๊กเดิมเข้าไปในระบบใหม่ทั้งดุ้น
 *
 * เลือกนิยามที่ "กว้างที่สุด" ในสามอันเป็นตัวตั้ง (ของ navCatalog) เพราะการ
 * รวมนิยามไม่ควรทำให้ใครที่วันนี้เข้าได้ พรุ่งนี้เข้าไม่ได้ การถอนสิทธิ์ควร
 * เป็นการตัดสินใจที่ตั้งใจทำผ่านหน้า /admin/rbac ไม่ใช่ผลข้างเคียงของ refactor
 */

/** แผนกที่นับเป็นแอดมินโดยตำแหน่ง */
const ADMIN_DEPARTMENTS = ["EXEC", "ADMIN"];

/**
 * คนนี้เป็นแอดมินไหม
 *
 * @param {Object|null} userInfo ค่าจาก state.auth.userInfo
 * @returns {boolean}
 */
export function isAdminUser(userInfo) {
  if (!userInfo) return false;

  const dept = String(userInfo.primaryDepartment || "").toUpperCase();

  // ไม่นับ role ADMIN จากตาราง tbl_user_roles แล้ว (25 ก.ย. 69) — หลังบ้านดูแค่ users.isAdmin
  // ถ้านับ role ด้วย คนที่มี role ADMIN แต่ isAdmin=0 จะเห็นปุ่มแอดมินครบ แต่กดแล้ว API ปฏิเสธหมด
  // ตั้ง/ถอดแอดมินที่หน้าของคน /admin/rbac/people/:id
  return (
    userInfo.isAdmin === true ||
    userInfo.isAdmin === 1 ||
    ADMIN_DEPARTMENTS.includes(dept)
  );
}

export { ADMIN_DEPARTMENTS };
